/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Nutrtiontags from './nutrtiontags';
import NutrtiontagsDetail from './nutrtiontags-detail';
import NutrtiontagsUpdate from './nutrtiontags-update';
import NutrtiontagsDeleteDialog from './nutrtiontags-delete-dialog';

const NutrtiontagsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Nutrtiontags />} />
    <Route path="new" element={<NutrtiontagsUpdate />} />
    <Route path=":id">
      <Route index element={<NutrtiontagsDetail />} />
      <Route path="edit" element={<NutrtiontagsUpdate />} />
      <Route path="delete" element={<NutrtiontagsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NutrtiontagsRoutes;
